import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import VideoAssetList from "./video-asset-list.vue";
import CommonHotVideo from "./common-hot-video.vue";
import { tabNameList } from "./config";
export default defineComponent({
    props: {
        resources: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        currentTab: {
            type: definePropType(Object),
            defualt: function() {
                return {
                    key: "",
                    tagId: "",
                    search: "",
                    componentsTitle: "",
                    type: 0
                };
            }
        }
    },
    components: {
        VideoAssetList: VideoAssetList,
        CommonHotVideo: CommonHotVideo
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleAddResource = function(res) {
            emit("addResource", res);
        };
        var viewTagAllData = function(tagInfo) {
            emit("viewTagAllData", tagInfo);
        };
        var getCommonHotComponents = function() {
            emit("backCommonHotComponents");
        };
        // 转码失败重试
        var retryEvent = function(id) {
            emit("retry", id);
        };
        return {
            tabNameList: tabNameList,
            retryEvent: retryEvent,
            handleAddResource: handleAddResource,
            viewTagAllData: viewTagAllData,
            getCommonHotComponents: getCommonHotComponents
        };
    }
});
